import { render, staticRenderFns } from "./multi-photo.vue?vue&type=template&id=7471d064&"
import script from "./multi-photo.vue?vue&type=script&lang=ts&"
export * from "./multi-photo.vue?vue&type=script&lang=ts&"
import style0 from "./multi-photo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports